import { TUploadType, UPLOAD_TYPES } from 'consts/uploadTypes'
import { IMyFilesMediaItem } from 'types/media'

const validateMimeType = (
  mimeType: string,
  validMimeTypes: readonly string[]
): boolean => {
  return validMimeTypes.some(validMimeType => {
    // Handle wildcards like 'image/*'
    if (validMimeType.endsWith('/*')) {
      const category = validMimeType.slice(0, -2)
      return mimeType.startsWith(category + '/')
    }
    // Exact MIME type match
    return mimeType === validMimeType
  })
}

const logInvalidFilesWarning = (hasInvalidFiles: boolean, message: string) => {
  if (hasInvalidFiles) {
    // eslint-disable-next-line no-console
    console.warn(message)
  }
}
import { useAlertPopupsContext } from 'context/AlertPopups'

export const useFileFormatValidator = (
  acceptType: TUploadType,
  validMimeTypes?: string[]
) => {
  const { setAlertPopupsData } = useAlertPopupsContext()
  const validateFiles = (files: File[]) => {
    const _validMimeTypes = validMimeTypes || UPLOAD_TYPES[acceptType]

    const validFiles = files.filter(file => {
      return validateMimeType(file.type, _validMimeTypes)
    })

    const hasInvalidFiles = validFiles.length !== files.length
    logInvalidFilesWarning(
      hasInvalidFiles,
      'Some files have unsupported format and were filtered out'
    )
    if (hasInvalidFiles) {
      setAlertPopupsData({
        errorPopup: {
          type: 'unsupportedFileFormat'
        }
      })

      // eslint-disable-next-line no-console
      console.warn('Some files have unsupported format and were filtered out')
    }

    return validFiles
  }

  return validateFiles
}

export const useMyFilesFormatValidator = (acceptType: TUploadType) => {
  const validateMyFiles = (files: IMyFilesMediaItem[]) => {
    const validMimeTypes = UPLOAD_TYPES[acceptType]

    const validFiles = files.filter(file => {
      return validateMimeType(file.mime, validMimeTypes)
    })

    const hasInvalidFiles = validFiles.length !== files.length
    logInvalidFilesWarning(
      hasInvalidFiles,
      'Some MyFiles have unsupported format and were filtered out'
    )

    return validFiles
  }

  return validateMyFiles
}
